/* ==========================================================================
   dtc-hero.js, scroll-shrink fallback for the hero.

   The preferred implementation is the CSS scroll-driven animation in
   dtc-hero.css (animation-timeline: scroll(root block)). This file exists
   ONLY for engines without animation-timeline support.

   Contract:
     - runs only when the section opted in (.dtc-hero--shrink)
     - runs only when CSS scroll timelines are unsupported
     - runs only when the user has not asked for reduced motion
     - reads scrollY, writes transform + opacity on ONE element, inside rAF.
       Zero layout reads per frame.
   ========================================================================== */
(function () {
  'use strict';

  var DTC = window.DTC;
  if (!DTC || !DTC.register) return;

  function cssScrollTimelines() {
    return typeof CSS !== 'undefined' &&
      CSS.supports &&
      CSS.supports('animation-timeline', 'scroll()');
  }

  DTC.register('hero', {
    init: function (root) {
      var block = root.querySelector('[data-dtc-hero-block]');
      if (!block) return;

      // Opted out in the editor, engine already handles it, or the visitor
      // prefers reduced motion -> leave the hero completely alone.
      if (!root.classList.contains('dtc-hero--shrink')) return;
      if (cssScrollTimelines()) return;
      if (DTC.reducedMotion) return;

      root.classList.add('dtc-hero--js');

      var ticking = false;
      var lastS = -1;
      var lastO = -1;
      var alive = true;

      function paint() {
        ticking = false;
        if (!alive) return;

        var y = window.pageYOffset || 0;
        // Exactly the prototype's curve.
        var s = Math.max(0.6, 1 - y / 1500);
        var o = Math.max(0, 1 - y / 640);

        // Round hard enough that we skip most no-op writes.
        s = Math.round(s * 1000) / 1000;
        o = Math.round(o * 1000) / 1000;

        if (s !== lastS) {
          block.style.transform = s === 1 ? '' : 'scale(' + s + ')';
          lastS = s;
        }
        if (o !== lastO) {
          block.style.opacity = o === 1 ? '' : String(o);
          lastO = o;
        }
      }

      function onScroll() {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(paint);
      }

      var offScroll = DTC.on(window, 'scroll', onScroll, { passive: true });
      var offResize = DTC.on(window, 'resize', onScroll, { passive: true });
      paint();

      return function cleanup() {
        alive = false;
        offScroll();
        offResize();
        root.classList.remove('dtc-hero--js');
        block.style.transform = '';
        block.style.opacity = '';
      };
    }
  });
})();
